import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Row, Col } from 'antd'
import { compose } from 'recompose'
import _ from 'lodash'
import moment from 'moment'
import './index.scss'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			currentEvents: [],
			currentEvent: null
		}

		this.handleHeadingAnimation = this.handleHeadingAnimation.bind(this)
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (_.has(nextProps.dashboardData, 'events')) {
		  return ({ currentEvents: nextProps.dashboardData.events }) // <- this is setState equivalent
		}
		return null
	  }

	componentDidMount() {
		this.handleHeadingAnimation()
	}

	handleHeadingAnimation() {
		var textWrapper = document.querySelector('.ml1 .letters')
		textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, '<span class=\'letter\'>$&</span>')

		window.anime.timeline({ loop: true })
			.add({
				targets: '.ml1 .letter',
				scale: [0.3,1],
				opacity: [0,1],
				translateZ: 0,
				easing: 'easeOutExpo',
				duration: 600,
				delay: (el, i) => 70 * (i+1)
			}).add({
				targets: '.ml1 .line',
				scaleX: [0,1],
				opacity: [0.5,1],
				easing: 'easeOutExpo',
				duration: 700,
				offset: '-=875',
				delay: (el, i, l) => 80 * (l - i)
			}).add({
				targets: '.ml1',
				opacity: 0,
				duration: 3000,
				easing: 'easeOutExpo',
				delay: 2000
			})
	}
    
	render() {
		const { currentEvents, currentEvent } = this.state
		const eventThumbnails = currentEvents.map((i) => {
			const imgUrl = (i.thumbnail_url) ? `${process.env.REACT_APP_BACKEND_API}${i.thumbnail_url}` : 
												'/assets/images/events-placeholder.png'
			return {
				original: imgUrl,
				thumbnail: imgUrl,
				originalTitle: i.name
			}
		})
		return (
			<React.Fragment>
				<Row>
					<h1 className="ml1">
						<span className="text-wrapper">
							<span className="line line1"></span>
							<span className="letters">THIS MONTH EVENT</span>
							<span className="line line2"></span>
						</span>
					</h1>
				</Row>
				<Row>
					{
						currentEvent &&
						<h2 style={{ color: 'gray' }}>{`${currentEvent.name} on ${moment(currentEvent.from_date).format('lll')}`}</h2>
					}
					<ImageGallery 
						slideDuration={1000}
						slideInterval={5000}
						autoPlay={true}
						items={eventThumbnails} 
						onSlide={(currentIndex) => {
							this.setState({ currentEvent: currentEvents[currentIndex] })
						}}
					/>
				</Row>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
